import { Backdrop } from '@mui/material';

import { LoadingView } from './LoadingView';

export function LoadingViewFullScreen({
  open,
  text,
}: {
  open: boolean;
  text?: string;
}) {
  return (
    <Backdrop open={open} sx={{ color: '#fff', zIndex: 1000 }}>
      <LoadingView text={text} />
    </Backdrop>
  );
}
